/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * フォントファミリー
 * @export
 */
export const FontFamily = {
  Gothic: 'gothic',
  Mincho: 'mincho',
  Monospace: 'monospace'
} as const
export type FontFamily = typeof FontFamily[keyof typeof FontFamily]

export function FontFamilyFromJSON(json: any): FontFamily {
  return FontFamilyFromJSONTyped(json, false)
}

export function FontFamilyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FontFamily {
  return json as FontFamily
}

export function FontFamilyToJSON(value?: FontFamily | null): any {
  return value as any
}
